import React from "react";
import {Table} from "antd";
import CircularLoader from "./CircularLoader";

const PagedList = (props) => {
    const {className, loading = false, emptyText = 'No items available', ...other} = props;

    if (loading) {
        return (
            <div className="ch-dataTable">
                <CircularLoader displayInElement={true} pageCentered={true} visible={true} />
            </div>
        )
    }

    return (
        <div className="ch-dataTable">
            <Table
                className={"" + (className ? " " +className : "")}
                // rowClassName="ch-table-row"
                pagination={{
                    hideOnSinglePage: true
                }}
                locale={{
                    emptyText: (
                        <span className="ch-warning-text">{emptyText}</span>
                    ),
                }}
                {...other}
            />
        </div>
    );
};

export default PagedList;